import { atom } from "recoil";


const HideCrumbsAtom = atom({
    default: false,
    key: 'HideCrumbs'
})

export default HideCrumbsAtom;